import Image from 'next/image'
import { langToCountryCode, langFlagAlt } from '@/i18n/langMeta'

type LangFlagProps = {
  lang: string
  width?: number
  className?: string
}

/**
 * Renders a small flag image (reliable on Windows vs emoji flags).
 */
export default function LangFlag({ lang, width = 22, className = '' }: LangFlagProps) {
  const code = langToCountryCode[lang as keyof typeof langToCountryCode] || 'un'
  const h = Math.round((width * 15) / 20)
  const src = `https://flagcdn.com/w40/${code}.png`
  const baseAlt =
    langFlagAlt[lang as keyof typeof langFlagAlt] ||
    (code === 'un' ? 'language selector flag' : `country flag ${code}`)
  const alt = `airestro360-image ${baseAlt}`

  return (
    <Image
      src={src}
      alt={alt}
      width={width}
      height={h}
      className={`lang-flag-img ${className}`.trim()}
      loading="lazy"
      decoding="async"
    />
  )
}
